
import Component, { mixins } from 'vue-class-component';
import BaseCmsBlock from '../CmsBlockMixin';

@Component
export default class GridBlock extends mixins(BaseCmsBlock) {
	get gridSlots(): string[] {
		return Object.keys(this.$slots);
	}
}
